import AgeRestriction from '@/lib/api/storefront/age-restriction';
import BlogsPages from '@/lib/api/storefront/blogs';
import Cart from '@/lib/api/storefront/cart';
import Collections from '@/lib/api/storefront/collections';
import CustomPages from '@/lib/api/storefront/custom-pages';
import Customer from '@/lib/api/storefront/customer';
import GeneralSetting from '@/lib/api/storefront/general';
import Homepage from '@/lib/api/storefront/homepage';
import Orders from '@/lib/api/storefront/orders';
import PaymentChannels from '@/lib/api/storefront/payment-channel';
import Promotion from '@/lib/api/storefront/promotion';
import StoreInfo from '@/lib/api/storefront/store-info';
import ThirdParty from '@/lib/api/storefront/third-party-analytic';
import WhatsAppWidget from '@/lib/api/storefront/whatsapp-widget';
import { AxiosInstance } from 'axios';

class StoreFront {
  public homepage: Homepage;
  public cart: Cart;
  public orders: Orders;
  public collections: Collections;
  public customPages: CustomPages;
  public customer: Customer;
  public blogsPages: BlogsPages;
  public thirdParty: ThirdParty;
  public general: GeneralSetting;
  public ageRestriction: AgeRestriction;
  public whatsappWidget: WhatsAppWidget;
  public storeInfo: StoreInfo;
  public promotion: Promotion;
  public paymentChannels: PaymentChannels;

  constructor(client: AxiosInstance) {
    this.homepage = new Homepage(client);
    this.cart = new Cart(client);
    this.collections = new Collections(client);
    this.orders = new Orders(client);
    this.customPages = new CustomPages(client);
    this.customer = new Customer(client);
    this.blogsPages = new BlogsPages(client);
    this.thirdParty = new ThirdParty(client);
    this.general = new GeneralSetting(client);
    this.ageRestriction = new AgeRestriction(client);
    this.whatsappWidget = new WhatsAppWidget(client);
    this.storeInfo = new StoreInfo(client);
    this.promotion = new Promotion(client);
    this.paymentChannels = new PaymentChannels(client);
  }

  setHost(host: string) {
    const fullHost = `https://${host}`;
    this.homepage.host = fullHost;
    this.cart.host = fullHost;
    this.orders.host = fullHost;
    this.collections.host = fullHost;
    this.customPages.host = fullHost;
    this.customer.host = fullHost;
    this.blogsPages.host = fullHost;
    this.thirdParty.host = fullHost;
    this.ageRestriction.host = fullHost;
    this.whatsappWidget.host = fullHost;
    this.storeInfo.host = fullHost;
    this.promotion.host = fullHost;
    this.paymentChannels.host = fullHost;
  }
}

export default StoreFront;
